import React from 'react';
import {CheckCircle2, Circle} from 'lucide-react';

export const readinessCard = 'rounded-2xl glass p-4 md:p-5 space-y-3';
export const readinessPaymentButton = 'rounded-full bg-gold text-navy text-xs font-semibold px-3 py-2';

// Match the established single-appointment card for every booking source.
export function ReadinessHeading({title='Ready for treatment?', label='Readiness', verdict, ready=false}) {
    return <div className="flex items-center justify-between">
        <div><div className="text-[10px] uppercase tracking-[0.24em] text-white/45">{label}</div>
            <h2 className="font-serif text-xl text-white mt-0.5">{title}</h2></div>
        {verdict && <div className={`text-xs uppercase tracking-[0.18em] px-3 py-1 rounded-full border ${ready
            ? 'border-emerald-400/50 bg-emerald-500/10 text-emerald-100'
            : 'border-amber-400/50 bg-amber-500/10 text-amber-100'}`} data-testid="readiness-verdict">{verdict}</div>}
    </div>;
}

export function ReadinessMoneyRow({label,hint,done,children}) {
    return <li className="py-2.5 flex flex-wrap items-center gap-3">
        <div className={`h-8 w-8 rounded-full grid place-items-center shrink-0 ${done ? 'bg-emerald-500/15 text-emerald-200' : 'bg-white/5 text-white/40'}`}>
            {done ? <CheckCircle2 className="h-4 w-4"/> : <Circle className="h-4 w-4"/>}
        </div>
        <div className="flex-1 min-w-[120px]"><div className="text-sm text-white break-words">{label}</div>
            <div className="text-[11px] text-white/50 break-words">{hint}</div></div>
        {children}
    </li>;
}
